import { render } from "./boxFiles.vue?vue&type=template&id=f3f8c548"
import script from "./boxFiles.vue?vue&type=script&lang=js"
export * from "./boxFiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__